import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {Apitest2, signin,checkcodelogin, hello,registerfinish,agentlogin} from '../../src/api/api.js';
// import {
//     auth,
//     facebookAuthProvider,
//     githubAuthProvider,
//     googleAuthProvider,
//     twitterAuthProvider
// } from "../firebase/firebase";
import {
    SIGNIN_FACEBOOK_USER,
    SIGNIN_GITHUB_USER,
    SIGNIN_GOOGLE_USER,
    SIGNIN_TWITTER_USER,
    SIGNIN_USER,
    SIGNINCODE_USER,
    SIGNINAGENT_USER,
    SIGNOUT_USER,
    SIGNUP_USER
} from "constants/ActionTypes";
import {showAuthMessage, userSignInSuccess, userSignOutSuccess, userSignUpSuccess,hideAuthLoader} from "actions/Auth";
import {
    userFacebookSignInSuccess,
    userGithubSignInSuccess,
    userGoogleSignInSuccess,
    userTwitterSignInSuccess
} from "../actions/Auth";

function persianToEnglish(value) {
    var newValue = "";
    for (var i = 0; i < value.length; i++) {
        var ch = value.charCodeAt(i);
        if (ch >= 1776 && ch <= 1785) // For Persian digits.
        {
            var newChar = ch - 1728;
            newValue = newValue + String.fromCharCode(newChar);
        } else if (ch >= 1632 && ch <= 1641) // For Arabic & Unix digits.
        {
            var newChar = ch - 1584;
            newValue = newValue + String.fromCharCode(newChar);
        } else
            newValue = newValue + String.fromCharCode(ch);
    }
    return newValue;
};


// const createUserWithEmailPasswordRequest = async (email, password) =>
//     await auth.createUserWithEmailAndPassword(email, password)
//         .then(authUser => authUser)
//         .catch(error => error);
//
// const signInUserWithEmailPasswordRequest = async (email, password) =>
//     await auth.signInWithEmailAndPassword(email, password)
//         .then(authUser => authUser)
//         .catch(error => error);


const custom = async (formData) =>
    await signin(formData)
        .then(authUser => authUser)
        .catch(error => error);


const customregisterfinish = async (formData) =>
    await registerfinish(formData)
        .then(authUser => authUser)
        .catch(error => error);

const customcodes= async (formData) =>
    await checkcodelogin(formData)
        .then(authUser => authUser)
        .catch(error => error);

const customagent= async (formData) =>
    await agentlogin(formData)
        .then(authUser => authUser)
        .catch(error => error);

//
// auth.signInWithEmailAndPassword(email, password)
// .then(authUser => authUser)
// .catch(error => error);


// const signOutRequest = async () =>
//     await auth.signOut()
//         .then(authUser => authUser)
//         .catch(error => error);


// const signInUserWithGoogleRequest = async () =>
//     await auth.signInWithPopup(googleAuthProvider)
//         .then(authUser => authUser)
//         .catch(error => error);
//
// const signInUserWithFacebookRequest = async () =>
//     await auth.signInWithPopup(facebookAuthProvider)
//         .then(authUser => authUser)
//         .catch(error => error);
//
// const signInUserWithGithubRequest = async () =>
//     await auth.signInWithPopup(githubAuthProvider)
//         .then(authUser => authUser)
//         .catch(error => error);
//
// const signInUserWithTwitterRequest = async () =>
//     await auth.signInWithPopup(twitterAuthProvider)
//         .then(authUser => authUser)
//         .catch(error => error);
//
// function* createUserWithEmailPassword({payload}) {
//     const {email, password} = payload;
//     try {
//         const signUpUser = yield call(createUserWithEmailPasswordRequest, email, password);
//         if (signUpUser.message) {
//             yield put(showAuthMessage(signUpUser.message));
//         } else {
//             localStorage.setItem('user_id', signUpUser.user.uid);
//             yield put(userSignUpSuccess(signUpUser.user.uid));
//         }
//     } catch (error) {
//         yield put(showAuthMessage(error));
//     }
// }


function* customsignin({payload}) {
    const {mobile, password} = payload;


    const formData = new FormData();
    formData.append("username", persianToEnglish(mobile));
    formData.append("password", password);

    try {

        const signInUser = yield call(custom, formData)

        debugger;
        if (signInUser.data.errorCode === 0) {

            localStorage.setItem('user_id','Token '+ signInUser.data.token);
            localStorage.setItem('damane',signInUser.data.profile.damane);
            yield put(userSignInSuccess(signInUser.data.token));
            debugger;

        } else {

             // yield put(showAuthMessage('کلمه عبور اشتباه است'));
             yield put(showAuthMessage(signInUser.data.errorDescription));
            debugger;


        }

    } catch (e) {
        yield put(hideAuthLoader());
    }


    //  localStorage.setItem('user_id', signUpUser.user.uid);
    //         yield put(userSignUpSuccess(signUpUser.user.uid));
    // yield put(userSignInSuccess(signInUser.user.uid));
}

function* customregisterfinishreq({payload}) {
    // const {Name,Username, Password,ucode,Email,Family,Organisation} = payload;
    const {newname, mobile, newpassword, ucode,family,email} = payload;

    console.log("do")
    debugger
    const formData = new FormData();
    formData.append("Username", persianToEnglish(mobile));
    formData.append("Password", newpassword);
    formData.append("Ucode", ucode);
    formData.append("Name", newname);
    formData.append("Family", family);

    formData.append("Email", email);
    // formData.append("Organisation", organisation);



    try {

        const signUp = yield call(customregisterfinish, formData)

        debugger;
        if (signUp.data.errorCode === 0) {

            localStorage.setItem('user_id','Token '+ signUp.data.token);
            localStorage.setItem('damane','');
            yield put(userSignInSuccess(signUp.data.token));

            debugger;

        } else {

            yield put(showAuthMessage(signUp.data.errorDescription));
            debugger;



        }

    } catch (e) {
        yield put(hideAuthLoader());
    }


    //  localStorage.setItem('user_id', signUpUser.user.uid);
    //         yield put(userSignUpSuccess(signUpUser.user.uid));
    // yield put(userSignInSuccess(signInUser.user.uid));
}

function* customcodesignin({payload}) {
    const {mobile, code} = payload;


    const formData = new FormData();
    formData.append("username", persianToEnglish(mobile));
    formData.append("code",persianToEnglish( code));

    try {

        const signInUser = yield call(customcodes, formData)

        debugger;
        if (signInUser.data.errorCode === 0) {
            // alert('asdsf');
            localStorage.setItem('user_id','Token '+ signInUser.data.token);
            localStorage.setItem('damane',signInUser.data.profile.damane);
            yield put(userSignInSuccess(signInUser.data.token));
            debugger;

        } else {

            debugger;
             // yield put(showAuthMessage('کلمه عبور اشتباه است'));
             yield put(showAuthMessage(signInUser.data.errorDescription));


        }

    } catch (e) {
        yield put(hideAuthLoader());
    }


    //  localStorage.setItem('user_id', signUpUser.user.uid);
    //         yield put(userSignUpSuccess(signUpUser.user.uid));
    // yield put(userSignInSuccess(signInUser.user.uid));
}
function* customagentsignin({payload}) {
    const {emailagent, passwordagent} = payload;

    debugger;
    const formData = new FormData();
    formData.append("email", emailagent);
    formData.append("password",passwordagent);

    try {

        const signInUser = yield call(customagent, formData)

        debugger;
        if (signInUser.data.errorCode === 0) {

            localStorage.setItem('user_id','Token '+ signInUser.data.token);
            // alert('asd');
            localStorage.setItem('damane',signInUser.data.profile.damane);
            yield put(userSignInSuccess(signInUser.data.token));
            debugger;

        } else {

            debugger;
             //yield put(showAuthMessage('کلمه عبور اشتباه است'));
            yield put(showAuthMessage(signInUser.data.errorDescription));

        }

    } catch (e) {
         yield put(hideAuthLoader());
    }


    //  localStorage.setItem('user_id', signUpUser.user.uid);
    //         yield put(userSignUpSuccess(signUpUser.user.uid));
    // yield put(userSignInSuccess(signInUser.user.uid));
}





// function* signInUserWithEmailPassword({payload}) {
//     const {email, password} = payload;
//     debugger;
//     try {
//         const signInUser = yield call(signInUserWithEmailPasswordRequest, email, password);
//         if (signInUser.message) {
//             yield put(showAuthMessage(signInUser.message));
//         } else {
//             localStorage.setItem('user_id', signInUser.user.uid);
//             yield put(userSignInSuccess(signInUser.user.uid));
//         }
//     } catch (error) {
//         yield put(showAuthMessage(error));
//     }
// }
//
//
// function* signInUserWithGoogle() {
//     try {
//         const signUpUser = yield call(signInUserWithGoogleRequest);
//         if (signUpUser.message) {
//             yield put(showAuthMessage(signUpUser.message));
//         } else {
//             localStorage.setItem('user_id', signUpUser.user.uid);
//             yield put(userGoogleSignInSuccess(signUpUser.user.uid));
//         }
//     } catch (error) {
//         yield put(showAuthMessage(error));
//     }
// }
//
//
// function* signInUserWithFacebook() {
//     try {
//         const signUpUser = yield call(signInUserWithFacebookRequest);
//         if (signUpUser.message) {
//             yield put(showAuthMessage(signUpUser.message));
//         } else {
//             localStorage.setItem('user_id', signUpUser.user.uid);
//             yield put(userFacebookSignInSuccess(signUpUser.user.uid));
//         }
//     } catch (error) {
//         yield put(showAuthMessage(error));
//     }
// }
//
//
// function* signInUserWithGithub() {
//     try {
//         const signUpUser = yield call(signInUserWithGithubRequest);
//         if (signUpUser.message) {
//             yield put(showAuthMessage(signUpUser.message));
//         } else {
//             localStorage.setItem('user_id', signUpUser.user.uid);
//             yield put(userGithubSignInSuccess(signUpUser.user.uid));
//         }
//     } catch (error) {
//         yield put(showAuthMessage(error));
//     }
// }
//
//
// function* signInUserWithTwitter() {
//     try {
//         const signUpUser = yield call(signInUserWithTwitterRequest);
//         if (signUpUser.message) {
//             if (signUpUser.message.length > 100) {
//                 yield put(showAuthMessage('Your request has been canceled.'));
//             } else {
//                 yield put(showAuthMessage(signUpUser.message));
//             }
//         } else {
//             localStorage.setItem('user_id', signUpUser.user.uid);
//             yield put(userTwitterSignInSuccess(signUpUser.user.uid));
//         }
//     } catch (error) {
//         yield put(showAuthMessage(error));
//     }
// }


// function* signOut() {
//     try {
//         const signOutUser = yield call(signOutRequest);
//         if (signOutUser === undefined) {
//             localStorage.setItem('user_id','');
//             yield put(userSignOutSuccess(signOutUser));
//         } else {
//             yield put(showAuthMessage(signOutUser.message));
//         }
//     } catch (error) {
//         yield put(showAuthMessage(error));
//     }
// }

// export function* createUserAccount() {
//     yield takeEvery(SIGNUP_USER, createUserWithEmailPassword);
// }
//
// export function* signInWithGoogle() {
//     yield takeEvery(SIGNIN_GOOGLE_USER, signInUserWithGoogle);
// }
//
// export function* signInWithFacebook() {
//     yield takeEvery(SIGNIN_FACEBOOK_USER, signInUserWithFacebook);
// }
//
// export function* signInWithTwitter() {
//     yield takeEvery(SIGNIN_TWITTER_USER, signInUserWithTwitter);
// }
//
// export function* signInWithGithub() {
//     yield takeEvery(SIGNIN_GITHUB_USER, signInUserWithGithub);
// }

export function* signInUser() {
    yield takeEvery(SIGNIN_USER, customsignin);
}
export function* signIncodeUser() {
    yield takeEvery(SIGNINCODE_USER, customcodesignin);
}
export function* signInagentUser() {
    yield takeEvery(SIGNINAGENT_USER, customagentsignin);
}
export function* userSignUp() {
    yield takeEvery(SIGNUP_USER, customregisterfinishreq);
}


// export function* signOutUser() {
//     yield takeEvery(SIGNOUT_USER, signOut);
// }

export default function* rootSaga() {
    yield all([fork(signInUser),fork(userSignUp),fork(signIncodeUser),fork(signInagentUser)

        ]);
}
